// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../formatDistance/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatDistance = convertToFP(fn, 2);
export default formatDistance;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/formatDistance/index.js
// module id = 871
// module chunks = 0